import { render, staticRenderFns } from "./AdditionalBtns.vue?vue&type=template&id=4569c1aa&scoped=true"
import script from "./AdditionalBtns.vue?vue&type=script&lang=ts"
export * from "./AdditionalBtns.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalBtns.vue?vue&type=style&index=0&id=4569c1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4569c1aa",
  null
  
)

export default component.exports